module.exports = function($scope)
{
  var vm = this;
  
  $scope.save = function () {
    $scope.closeThisDialog({action:"save", note: vm.note})
  }
  
  $scope.close = function () {
    $scope.closeThisDialog({action:"close"});  
  } 
}
